import type { FC } from 'react'
import React, { useEffect } from 'react'
import type { ColorScheme } from './use-color-scheme.js'

export interface TunaThemeProps {
  colorScheme?: ColorScheme
  children?: React.ReactNode
}

/**
 * TunaTheme applies the color scheme class to the document root.
 * Design tokens are provided by tokens.css (imported at app root).
 */
export const TunaTheme: FC<TunaThemeProps> = ({ colorScheme, children }) => {
  useEffect(() => {
    if (!colorScheme) {
      return
    }
    document.documentElement.classList.remove('light', 'dark')
    document.documentElement.classList.add(colorScheme)
  }, [colorScheme])

  return <>{children}</>
}
